module.exports = __webpack_public_path__ + "static/9-8eb31f03db2d784d9dd4f0161d1287dd.png";